import Styles from './CourseOverView.module.scss'
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import {
    List, ListItem, Collapse, ListItemButton, ListItemText, Dialog,
    ListItemIcon, Divider, Fade, Box, Tab, Typography, Tooltip, Chip
} from '@mui/material';
import { useState, useEffect, useRef, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { AuthContext, useAPI } from 'components/lib';
import React from 'react';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { LmsCertificate } from 'components/LmsCertificate/LmsCertificate'
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';


//icons
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import PlayCircleOutlinedIcon from '@mui/icons-material/PlayCircleOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import QuizOutlinedIcon from '@mui/icons-material/QuizOutlined';
import StyleIcon from '@mui/icons-material/Style';
import MilitaryTechOutlinedIcon from '@mui/icons-material/MilitaryTechOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { use } from 'i18next';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';


// import { useContext } from 'react';


export function CourseOverView({ course_id, isPreview = false, props }) {
    const [currentDetail, setCurrentDetail] = useState('1');
    const [showModuleLectures, setShowModuleLectures] = useState([]);
    const [courseInformation, setCourseInformation] = useState();
    const [downloadOpen, setDownloadOpen] = useState(false);
    const [exporting, setExporting] = useState(false);
    const [certReady, setCertReady] = useState(false);
    const [consentChecked, setConsentChecked] = useState(false);
    const [proceedToRender, setProceedToRender] = useState(false);
    const { courseId } = useParams();
    const componentRef = useRef();
    const { data, loading } = useAPI(course_id ? `/api/lms/courses/${course_id}/info` : `/api/lms/courses/${courseId}/info`);
    const navigate = useNavigate();
    const context = useContext(AuthContext)

    useEffect(() => {
        if (data) {
            setCourseInformation(data)
            document.title = `Course Overview: ${data?.courseData?.course_name}`
        }
    }, [data])
    useEffect(() => {
        if (downloadOpen) setCertReady(false);
    }, [downloadOpen]);


    const handleTabChange = (event, newValue) => {
        setCurrentDetail(newValue);
    };
    const openModal = () => {
        setCertReady(false);
        setConsentChecked(false);
        setProceedToRender(false);
        setDownloadOpen(true);
    };
    const closeModal = () => {
        setDownloadOpen(false);
        setConsentChecked(false);
        setProceedToRender(false);
    };
    const onCertificateReady = () => {
        requestAnimationFrame(() => {
            setCertReady(true)
        });
    };
    function onShowSelection(id) {
        if (showModuleLectures.includes(id)) {
            return setShowModuleLectures(prevState => prevState.filter(item => item !== id));
        }
        setShowModuleLectures([...showModuleLectures, id]);
    }

    function iconSelector(type) {
        switch (type) {
            case 'video':
            case 'video_ai_transcript':
                return <PlayCircleOutlinedIcon sx={{ color: '#967bb6' }} />
            case 'quiz':
                return <QuizOutlinedIcon sx={{ color: '#967bb6' }} />
            case 'document':
                return <AssignmentOutlinedIcon sx={{ color: '#967bb6' }} />
            default:
                return <AssignmentOutlinedIcon sx={{ color: '#967bb6' }} />
        }
    }
    // Go to enrolled page
    function goToCourse() {
        navigate(`/lms/courses/${courseId}/modules`);
    }

    function onEnroll() {
        axios.post(`/api/lms/courses/${courseId}/enroll`)
            .then(response => {
                toast.dark(`You Have Successfully Enrolled To "${courseInformation?.courseData?.course_name}"`, {
                    type: 'success',
                    position: 'top-right',
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });

                setTimeout(() => {
                    navigate(`/lms/courses`);
                }, 2000);

            })
            .catch(error => {
                console.error('Error:', error);
                toast.dark(`Something went wrong, please try again.`, {
                    type: 'error',
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    }
    // Function to convert UTC date to local date and format it as dd mm yy
    function formatDueDate(utcDate) {
        const date = new Date(utcDate);
        const localDate = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));

        const day = String(localDate.getDate()).padStart(2, '0');
        const month = String(localDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = String(localDate.getFullYear()).slice(-2); // Get last 2 digits of year

        return `${day}/${month}/${year}`;
    }
    const handleDownloadPDF = async () => {
        const element = componentRef.current;
        if (!element) {
            console.error('No certificate element found to export');
            toast.dark('Certificate not ready. Try again.', { type: 'error' });
            return;
        }

        try {
            setExporting(true);

            const originalWidth = element.style.width;
            const originalOverflow = element.style.overflow;

            element.style.width = `${element.scrollWidth}px`;
            element.style.overflow = "visible";

            // choose scale for crispness (2 is a good default; increase for higher DPI)
            const scale = Math.max(2, window.devicePixelRatio || 1);

            const canvas = await html2canvas(element, {
                scale,
                useCORS: true,
                allowTaint: false,
                logging: false,
                scrollX: 0,
                scrollY: 0,
                windowWidth: element.scrollWidth,
                windowHeight: element.scrollHeight,
            });

            element.style.width = originalWidth;
            element.style.overflow = originalOverflow;

            const imgData = canvas.toDataURL('image/png');

            // create jsPDF in mm with A4 landscape
            const pdf = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: 'a4',
            });

            const pdfWidthMM = 297;
            const pdfHeightMM = 210;

            // Convert canvas px -> mm using approximate px-per-inch
            const pxPerInch = 96 * scale; // html2canvas uses approx 96 DPI baseline
            const imgWidthMM = (canvas.width / pxPerInch) * 25.4;
            const imgHeightMM = (canvas.height / pxPerInch) * 25.4;

            // Fit while preserving aspect ratio
            const ratio = Math.min(pdfWidthMM / imgWidthMM, pdfHeightMM / imgHeightMM);
            const renderedWidth = imgWidthMM * ratio;
            const renderedHeight = imgHeightMM * ratio;
            const x = (pdfWidthMM - renderedWidth) / 2;
            const y = (pdfHeightMM - renderedHeight) / 2;

            pdf.addImage(imgData, 'PNG', x, y, renderedWidth, renderedHeight);

            // filename (sanitize if required)
            const filename = `certificate_${courseId || course_id || 'unknown'}.pdf`;
            pdf.save(filename);

            // toggle download dialog close (same behaviour you had)
            setDownloadOpen(false);

            toast.dark('Certificate downloaded', { type: 'success' });
        } catch (err) {
            console.error('Export to PDF failed', err);
            toast.dark('Could not export certificate. Try again or contact support.', { type: 'error' });
        } finally {
            setExporting(false);
        }
    };

    const mediaUrl = courseInformation?.courseData?.isCustomImage === 1
        ? process.env.REACT_APP_AZURE_STORAGE_MEDIA_URL
        : process.env.REACT_APP_GLOBAL_MEDIA_URL;

    return (
        <>
            <ToastContainer
                id="warning-toast"
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <LoadingBackdrop
                isOpen={loading}
            />
            <div className={Styles.redirectButtons}>
                <button onClick={() => navigate(`/lms/courses`)} className={Styles.courseReview}>
                    <FeatherIcon size="0.9em" icon="chevron-left" /> Enrolled Courses
                </button>
            </div>
            {data && (
                <div className={Styles.ancestorContainer}>
                    <div className={Styles.titleContainer}>

                        {(courseInformation?.lmsLead && !isPreview) &&
                            <button
                                onClick={() => { navigate(`/lms/course/${courseId}/edit`) }}
                                className={Styles.editCourseBtn}
                            >
                                Edit Course
                            </button>
                        }
                        {(courseInformation?.isEnrolled && !isPreview) &&
                            <Tooltip
                                title={
                                    courseInformation?.cert_unlocked ? (
                                        <Typography fontSize={12}>Click here to download certificate!</Typography>
                                    ) : (
                                        <Typography fontSize={12}>Complete the course to download certificate</Typography>
                                    )
                                }
                                arrow
                                placement="bottom"
                                sx={{ margin: '-32px -24px 0px 0px' }}
                            >
                                <button
                                    onClick={openModal}
                                    className={Styles.downloadCertBtn}
                                    disabled={!courseInformation?.cert_unlocked}
                                >
                                    Download Certificate
                                </button>
                            </Tooltip>
                        }
                        <p className={Styles.courseTitle}>{courseInformation?.courseData?.course_name}</p>
                        <p className={Styles.courseSubTitle}>{courseInformation?.courseData?.subtitle}</p>
                    </div>
                    <div className={Styles.courseContentContainer}>
                        <TabContext sx={{ border: '1px solid blue' }} value={currentDetail}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider', backgroundColor: '#fff', borderTopLeftRadius: '0.4em', borderTopRightRadius: '0.4em' }}>
                                <TabList
                                    textColor='primary'
                                    indicatorColor="primary"
                                    variant='fullWidth'
                                    onChange={handleTabChange}
                                    aria-label="lab API tabs example"
                                >
                                    <Tab label='Content' value="1" />
                                    <Tab label='Description' value="2" />
                                </TabList>
                            </Box>
                            <Box className={Styles.contents} sx={{ flex: 1, maxHeight: '100%', overflow: 'auto' }}>
                                <TabPanel value="1" sx={{ padding: "0.7em" }}>
                                    <Fade in>
                                        <List
                                            sx={{
                                                padding: 0,
                                                // border:'1px solid red',
                                                backgroundColor: 'white',
                                                height: '100%',
                                                maxHeight: '100%'
                                            }}
                                        >
                                            {
                                                courseInformation?.courseModules?.map((module, modIndex) => {
                                                    return (
                                                        <React.Fragment
                                                            key={module.module_id}
                                                        >
                                                            {modIndex !== 0 && <Divider />}
                                                            <ListItemButton
                                                                onClick={() => { onShowSelection(module.module_id) }}
                                                            >
                                                                <ListItemText
                                                                    secondary={`${module?.total_lectures} Lectures`}
                                                                >
                                                                    <p style={{ fontSize: '1em', fontWeight: 600 }}>{module.module_title}</p>
                                                                </ListItemText>

                                                                {showModuleLectures.includes(module.module_id) ? <ExpandLess /> : <ExpandMore />}
                                                            </ListItemButton>
                                                            <Collapse in={showModuleLectures.includes(module.module_id)} timeout="auto" unmountOnExit>
                                                                <List component="div" disablePadding>
                                                                    {
                                                                        module?.module_lectures?.map((lecture, secIndex) => {
                                                                            return (
                                                                                <ListItem
                                                                                    key={lecture?.lecture_id}
                                                                                    sx={{ pl: 4 }}
                                                                                >
                                                                                    <ListItemIcon>
                                                                                        {iconSelector(lecture?.lecture_type)}
                                                                                    </ListItemIcon>
                                                                                    <ListItemText>
                                                                                        <p style={{ fontSize: '1em' }}>{lecture?.lecture_title}</p>
                                                                                    </ListItemText>
                                                                                </ListItem>
                                                                            )
                                                                        })
                                                                    }

                                                                </List>
                                                            </Collapse>
                                                        </React.Fragment>
                                                    )
                                                })
                                            }

                                        </List>
                                    </Fade>
                                </TabPanel>
                                <TabPanel value="2" sx={{ height: '100%', overflow: 'auto' }}>
                                    <Fade in>
                                        <Box >
                                            <Typography
                                                variant='h5'
                                                color="black"
                                                sx={{
                                                    marginBottom: '0.4em',
                                                    fontWeight: 600
                                                }}
                                            >
                                                Description
                                            </Typography>
                                            <Typography variant='body2' sx={{ whiteSpace: 'pre-wrap' }}>
                                                {courseInformation?.courseData?.course_desc}

                                            </Typography>

                                            {courseInformation?.courseData?.goals?.length > 0 &&
                                                <Typography
                                                    variant='h6'
                                                    color="black"
                                                    sx={{
                                                        marginBottom: '0.4em',
                                                        marginTop: '0.8em',
                                                        fontWeight: 600
                                                    }}
                                                >
                                                    Goals
                                                </Typography>
                                            }
                                            <div className={Styles.goalsContainer}>
                                                {
                                                    courseInformation?.courseData?.goals?.map((goal, index) => (
                                                        <div
                                                            key={`${goal}_${index}`}
                                                            className={Styles.goals}
                                                        >
                                                            <CheckCircleOutlineOutlinedIcon
                                                                fontSize='small'
                                                                sx={{
                                                                    color: 'green',
                                                                    width: '0.8em',
                                                                    marginTop: '0.05em'
                                                                }}
                                                            />
                                                            <Typography
                                                                variant='body2'
                                                            >
                                                                {goal}
                                                            </Typography>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </Box>
                                    </Fade>
                                </TabPanel>
                            </Box>
                        </TabContext>
                    </div>
                    <div className={Styles.priceAndDetails}>
                        <div className={Styles.enrollContainer}>
                            <div className={Styles.imgBox}>
                                <img src={`${mediaUrl}${courseInformation?.courseData?.course_icon}`} alt={courseInformation?.courseData?.course_name} />
                            </div>
                            {<AivagamButton
                                buttonText={!courseInformation?.isEnrolled ? 'Enroll' : "Go to Course"}
                                type='action'
                                classStyles={{ width: '100%', fontWeight: 600, borderRadius: '0.4em', display: isPreview ? 'none' : null }}
                                onClick={!courseInformation?.isEnrolled ? onEnroll : goToCourse}
                            />}
                        </div>
                        <div className={Styles.whatsIncluded}>
                            <Typography variant='h6' color='black' sx={{ padding: '0.3em 0', fontWeight: 600 }}>
                                Course Insights
                            </Typography>
                            <Divider />
                            <span>
                                <MilitaryTechOutlinedIcon sx={{ color: '#1B6EDA' }} />
                                <Typography variant='subtitle1' color='black' style={{ textTransform: 'capitalize' }}>
                                    {courseInformation?.courseData?.level ? courseInformation?.courseData?.level + ' Level' : 'For All Levels'}
                                </Typography>
                            </span>
                            <Divider />
                            <span>
                                <PlayCircleOutlinedIcon sx={{ color: '#967bb6' }} />
                                <Typography variant='subtitle1' color='black' >
                                    {Math.ceil((courseInformation?.includedContent?.videos * 15) / 60)}+  Hours Of Videos
                                </Typography>
                            </span>
                            <Divider />
                            <span>
                                <AssignmentOutlinedIcon sx={{ color: 'green' }} />
                                <Typography variant='subtitle1' color='black' >
                                    {courseInformation?.includedContent?.documents} Articles
                                </Typography>
                            </span>
                            <Divider />
                            <span>
                                <QuizOutlinedIcon sx={{ color: '#ffbf00' }} />
                                <Typography variant='subtitle1' color='black' >
                                    {courseInformation?.includedContent?.quizzes} Quizzes
                                </Typography>
                            </span>
                            {courseInformation?.due_date && (
                                <>
                                    <Divider />
                                    <span>
                                        <CalendarTodayOutlinedIcon sx={{ color: '#FF0000' }} />
                                        <Typography variant='subtitle1' color='black' className={Styles.dueDate}>
                                            {formatDueDate(courseInformation.due_date)} Due Date
                                        </Typography>
                                    </span>
                                </>
                            )}
                            {courseInformation?.courseData?.tagNames && <>
                                <Divider />
                                <span>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span style={{ padding: '0px' }}>
                                            <StyleIcon sx={{ color: '#fc0a0abd' }} />
                                            <Typography variant='subtitle1' color='black' >
                                                Skills you'll learn
                                            </Typography>
                                        </span>
                                        <div className={Styles.tagsContainer}>
                                            {courseInformation?.courseData.tagNames.map((tag, index) =>
                                            (
                                                <div key={`${index}-${tag}`}>
                                                    <Chip
                                                        label={tag}
                                                        size="small"
                                                    />
                                                </div>
                                            )
                                            )}
                                        </div>
                                    </div>
                                </span>
                            </>
                            }
                        </div>
                        <div>

                        </div>
                    </div>
                </div>
            )}
            <Dialog
                open={downloadOpen}
                maxWidth={false}
                maxHeight={false}
                onClose={() => { closeModal(); }}
            >
                <div style={{ padding: 20, minWidth: 520 }}>
                    {!!context?.user?.onboarded ? (
                        !proceedToRender ? (
                            <div className={Styles.tcContainer}>
                                <h3 className={Styles.tcTitle}>Terms & Conditions</h3>
                                <p className={Styles.tcBody}>
                                    Please confirm that you agree to the terms before generating your certificate.
                                </p>

                                <label className={Styles.tcCheckboxLabel}>
                                    <input
                                        id="cert-consent"
                                        className={Styles.tcCheckbox}
                                        type="checkbox"
                                        checked={consentChecked}
                                        onChange={(e) => setConsentChecked(e.target.checked)}
                                    />
                                    <span className={Styles.tcCheckboxText}>
                                        I hereby agree to sign with my name as a signature on the certificate
                                    </span>
                                </label>

                                <div className={Styles.tcActions}>
                                    <AivagamButton
                                        id='cancelDownload'
                                        buttonText="Cancel"
                                        onClick={closeModal}
                                        type="cancel"
                                    />
                                    <AivagamButton
                                        id='proceedToRender'
                                        buttonText="Proceed"
                                        onClick={() => setProceedToRender(true)}
                                        disabled={!consentChecked}
                                        type="confirm"
                                    />
                                </div>
                            </div>
                        ) : (
                            <div>
                                <div className={Styles.downloadActionBtnContainer}>
                                    <AivagamButton
                                        id='cancelDownload'
                                        buttonText={"Cancel"}
                                        onClick={closeModal}
                                        type="cancel"
                                    />
                                    <AivagamButton
                                        id='confirmDownload'
                                        buttonText={exporting ? 'Generating...' : !certReady ? 'Preparing…' : 'Confirm Download'}
                                        onClick={handleDownloadPDF}
                                        type="confirm"
                                        disabled={exporting}
                                    />
                                </div>

                                <div className={Styles.showCertificateContent}
                                    style={{ position: 'relative', minHeight: 320, minWidth: 520 }}
                                >
                                    <div
                                        ref={componentRef}
                                        id='certificate'
                                        style={{
                                            display: 'block',
                                            visibility: certReady ? 'visible' : 'hidden',
                                            minHeight: 320,
                                            pointerEvents: certReady ? 'auto' : 'none'
                                        }}
                                    >
                                        <LmsCertificate
                                            courseId={courseId}
                                            onReady={onCertificateReady}
                                        />
                                    </div>
                                </div>

                                <LoadingBackdrop
                                    isOpen={proceedToRender && (!certReady || exporting)}
                                />
                            </div>
                        )) : (<div className={Styles.tcContainer}>
                            <h3 className={Styles.tcTitle}>Profile Incomplete</h3>
                            <p className={Styles.tcBody}>
                                Please complete your profile setup in the Accounts section to get the
                                certificate.
                            </p>

                            <div className={Styles.tcActions}>
                                <AivagamButton
                                    id="closeNotOnboarded"
                                    buttonText="Close"
                                    onClick={closeModal}
                                    type="cancel"
                                />
                                <AivagamButton
                                    id="goToAccount"
                                    buttonText="Go to Account"
                                    onClick={() => navigate("/account")}
                                    type="confirm"
                                />
                            </div>
                        </div>)}
                </div>
            </Dialog>

        </>
    )
}
